import { ref } from 'vue'

export const languageIdBus = ref(3)
